/* global window */
import { h } from './element';
import { bind, mouseMoveUp, bindTouch, createEventEmitter, unbind } from './event';
import Resizer from './resizer';
import Scrollbar from './scrollbar';
import Selector from './selector';
import Editor from './editor';
import Print from './print';
import ContextMenu from './contextmenu';
import ContextSubMenu from './context_submenu';
import Table from './table';
import Toolbar from './toolbar/index';
import ModalValidation from './modal_validation';
import SortFilter from './sort_filter';
import { xtoast } from './message';
import config, { cssPrefix } from '../config';
import { formulas } from '../core/formula';
import BackgroundImage from './backgroundImg';
import ImageManage from './manage/image_manage';
import BlockManage from './manage/block-manage';
import FormConfigManage from './manage/form-config-manage';
import { CellRange } from '../core/cell_range';
import DataConfigManage from './manage/data-config-manage';

/**
 * @desc throttle fn
 * @param func function
 * @param wait Delay in milliseconds
 */
function throttle(func, wait) {
  let timeout;
  return (...arg) => {
    const that = this;
    const args = arg;
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(that, args);
      }, wait);
    }
  };
}

function scrollbarMove() {
  const {
    data, verticalScrollbar, horizontalScrollbar,
  } = this;
  const {
    l, t, left, top, width, height,
  } = data.getSelectedRect();
  const tableOffset = this.getTableOffset();
  // console.log(',l:', l, ', left:', left, ', tOffset.left:', tableOffset.width);
  if (Math.abs(left) + width > tableOffset.width) {
    horizontalScrollbar.move({ left: l + width - tableOffset.width });
  } else {
    const fsw = data.freezeTotalWidth();
    if (left < fsw) {
      horizontalScrollbar.move({ left: l - 1 - fsw });
    }
  }
  // console.log('top:', top, ', height:', height, ', tof.height:', tableOffset.height);
  if (Math.abs(top) + height > tableOffset.height) {
    verticalScrollbar.move({ top: t + height - tableOffset.height - 1 });
  } else {
    const fsh = data.freezeTotalHeight();
    if (top < fsh) {
      verticalScrollbar.move({ top: t - 1 - fsh });
    }
  }
}

function selectorSet(multiple, ri, ci, indexesUpdated = true, moving = false) {
	const {
    table, selector, toolbar, data,
    contextMenu,
  } = this;
	//代码库修改
	if (data.cols.len == ci) { //点击加号按钮
		// this.trigger('cell-selected', null, ri, ci);
		return;
	}
  if (ri === -1 && ci === -1) return;
  
  contextMenu.setMode((ri === -1 || ci === -1) ? 'row-col' : 'range');
  const cell = data.getCell(ri, ci);
  if (multiple) {
    selector.setEnd(ri, ci, moving);
    this.trigger('cells-selected', cell, selector.range);
    if (this.areaType) { //如果划定区域
      
    }
  } else {
    // trigger click event
    selector.set(ri, ci, indexesUpdated);
    this.trigger('cell-selected', cell, ri, ci);
  }
  toolbar.reset();
  //选择cell禁止table刷新
  // table.render();
}

// multiple: boolean
// direction: left | right | up | down | row-first | row-last | col-first | col-last
function selectorMove(multiple, direction) {
  const {
    selector, data,
  } = this;
  const { rows, cols } = data;
  let [ri, ci] = selector.indexes;
  const { eri, eci } = selector.range;
  if (multiple) {
    [ri, ci] = selector.moveIndexes;
  }
  // console.log('selector.move:', ri, ci);
  if (direction === 'left') {
    if (ci > 0) ci -= 1;
  } else if (direction === 'right') {
    if (eci !== ci) ci = eci;
    if (ci < cols.len - 1) ci += 1;
  } else if (direction === 'up') {
    if (ri > 0) ri -= 1;
  } else if (direction === 'down') {
    if (eri !== ri) ri = eri;
    if (ri < rows.len - 1) ri += 1;
  } else if (direction === 'row-first') {
    ci = 0;
  } else if (direction === 'row-last') {
    ci = cols.len - 1;
  } else if (direction === 'col-first') {
    ri = 0;
  } else if (direction === 'col-last') {
    ri = rows.len - 1;
  }
  if (multiple) {
    selector.moveIndexes = [ri, ci];
  }
  selectorSet.call(this, multiple, ri, ci);
  scrollbarMove.call(this);
}

// private methods
function overlayerMousemove(evt) {
  // console.log('x:', evt.offsetX, ', y:', evt.offsetY);
  if (evt.buttons !== 0) return;
  if (evt.target.className === `${cssPrefix}-resizer-hover`) return;
  const { offsetX, offsetY } = evt;
  const {
    rowResizer, colResizer, tableEl, data,
  } = this;
  const { rows, cols } = data;
  if (offsetX > cols.indexWidth && offsetY > rows.height) {
    rowResizer.hide();
    colResizer.hide();
    return;
  }
  const tRect = tableEl.box();
  const cRect = data.getCellRectByXY(evt.offsetX, evt.offsetY);
	//代码库修改
	if (cRect.colLen == cRect.ci) { //点击加号按钮
		// this.trigger('cell-selected', null, ri, ci);
		return;
	}
  if (cRect.ri >= 0 && cRect.ci === -1) {
    cRect.width = cols.indexWidth;
    rowResizer.show(cRect, {
      width: tRect.width,
    });
    if (rows.isHide(cRect.ri - 1)) {
      rowResizer.showUnhide(cRect.ri);
    } else {
      rowResizer.hideUnhide();
    }
  } else {
    rowResizer.hide();
  }
  if (cRect.ri === -1 && cRect.ci >= 0) {
    cRect.height = rows.height;
    colResizer.show(cRect, {
      height: tRect.height,
    });
    if (cols.isHide(cRect.ci - 1)) {
      colResizer.showUnhide(cRect.ci);
    } else {
      colResizer.hideUnhide();
    }
  } else {
    colResizer.hide();
  }
}

// private methods
function overlayerMouseup(evt) {
  const {
    table, selector, toolbar, data,
    contextMenu,currentForm,
  } = this;
  
  if(data.selector.multiple() && this.areaType) {
    console.log('this......., ', data.selector);
    const selector = data.selector;
    console.log('selector:', selector);
    console.log('currentForm......., ', currentForm);
    if (this.areaType) {
      switch (this.areaType) {
        case 'area':
          formAreaForm.call(this,'set',currentForm,this.areaType);
          break;
        case 'title':
          formAreaForm.call(this,'set',currentForm,this.areaType);
          break;
        case 'title-row':
          formAreaForm.call(this,'set',currentForm,this.areaType);
          break;
        case 'first-row':
          formAreaForm.call(this,'set',currentForm,this.areaType);
          break;
        default:
          break;
      }
      this.areaType = '';
    }
    clearClipboard.call(this);
    sheetReset.call(this);
  }
}

// let scrollThreshold = 15;
function overlayerMousescroll(evt) {
  // scrollThreshold -= 1;
  // if (scrollThreshold > 0) return;
  // scrollThreshold = 15;

  const { verticalScrollbar, horizontalScrollbar, data } = this;
  const { top } = verticalScrollbar.scroll();
  const { left } = horizontalScrollbar.scroll();
  // console.log('evt:::', evt.wheelDelta, evt.detail * 40);

  const { rows, cols } = data;

  // deltaY for vertical delta
  const { deltaY, deltaX } = evt;
  const loopValue = (ii, vFunc) => {
    let i = ii;
    let v = 0;
    do {
      v = vFunc(i);
      i += 1;
    } while (v <= 0);
    return v;
  };
  // console.log('deltaX', deltaX, 'evt.detail', evt.detail);
  // if (evt.detail) deltaY = evt.detail * 40;
  const moveY = (vertical) => {
    if (vertical > 0) {
      // up
      const ri = data.scroll.ri + 1;
      if (ri < rows.len) {
        const rh = loopValue(ri, i => rows.getHeight(i));
        verticalScrollbar.move({ top: top + rh - 1 });
      }
    } else {
      // down
      const ri = data.scroll.ri - 1;
      if (ri >= 0) {
        const rh = loopValue(ri, i => rows.getHeight(i));
        verticalScrollbar.move({ top: ri === 0 ? 0 : top - rh });
      }
    }
  };

  // deltaX for Mac horizontal scroll
  const moveX = (horizontal) => {
    if (horizontal > 0) {
      // left
      const ci = data.scroll.ci + 1;
      if (ci < cols.len) {
        const cw = loopValue(ci, i => cols.getWidth(i));
        horizontalScrollbar.move({ left: left + cw - 1 });
      }
    } else {
      // right
      const ci = data.scroll.ci - 1;
      if (ci >= 0) {
        const cw = loopValue(ci, i => cols.getWidth(i));
        horizontalScrollbar.move({ left: ci === 0 ? 0 : left - cw });
      }
    }
  };
  const tempY = Math.abs(deltaY);
  const tempX = Math.abs(deltaX);
  const temp = Math.max(tempY, tempX);
  // console.log('event:', evt);
  // detail for windows/mac firefox vertical scroll
  if (/Firefox/i.test(window.navigator.userAgent)) throttle(moveY(evt.detail), 50);
  if (temp === tempX) throttle(moveX(deltaX), 50);
  if (temp === tempY) throttle(moveY(deltaY), 50);
}

function overlayerTouch(direction, distance) {
  const { verticalScrollbar, horizontalScrollbar } = this;
  const { top } = verticalScrollbar.scroll();
  const { left } = horizontalScrollbar.scroll();

  if (direction === 'left' || direction === 'right') {
    horizontalScrollbar.move({ left: left - distance });
  } else if (direction === 'up' || direction === 'down') {
    verticalScrollbar.move({ top: top - distance });
  }
}

function verticalScrollbarSet() {
  const { data, verticalScrollbar } = this;
  const { height } = this.getTableOffset();
  const erth = data.exceptRowTotalHeight(0, -1);
  // console.log('erth:', erth);
  verticalScrollbar.set(height, data.rows.totalHeight() - erth);
}

function horizontalScrollbarSet() {
  const { data, horizontalScrollbar } = this;
  const { width } = this.getTableOffset();
  if (data) {
    horizontalScrollbar.set(width, data.cols.totalWidth());
  }
}

function sheetFreeze() {
  const {
    selector, data, editor,backgroundImg
  } = this;
  const [ri, ci] = data.freeze;
  if (ri > 0 || ci > 0) {
    const fwidth = data.freezeTotalWidth();
    const fheight = data.freezeTotalHeight();
    editor.setFreezeLengths(fwidth, fheight);
  }
  selector.resetAreaOffset();
}

function sheetReset() {
  const {
    tableEl,
    overlayerEl,
    overlayerCEl,
    table,
    toolbar,
    selector,
    el,
  } = this;
  const tOffset = this.getTableOffset();
  const vRect = this.getRect();
  tableEl.attr(vRect);
  overlayerEl.offset(vRect);
  overlayerCEl.offset(tOffset);
  el.css('width', `${vRect.width}px`);
  verticalScrollbarSet.call(this);
  horizontalScrollbarSet.call(this);
  sheetFreeze.call(this);
  table.render();
  toolbar.reset();
  selector.reset();
}

function clearClipboard() {
  const { data, selector } = this;
  data.clearClipboard();
  selector.hideClipboard();
}

function copy() {
  const { data, selector } = this;
  data.copy();
  data.copyToSystemClipboard();
  selector.showClipboard();
}

function cut() {
  const { data, selector } = this;
  data.cut();
  selector.showClipboard();
}

function paste(what, evt) {
  const { data } = this;
  if (data.settings.mode === 'read') return;
  console.log("data.clipboard......",data.clipboard);
  console.log("data.clipboard.isCopy()......",data.clipboard.isCopy());
  console.log("data.clipboard.range......",data.clipboard.range);
  console.log("data.selector.....",data.selector);
  let isCut = data.clipboard.isCut();
  let cutRange = data.clipboard.range;
  if (data.paste(what, msg => xtoast('Tip', msg))) {
    console.log("data.clipboard.isCut()......",isCut);
    //清空被剪切的图片
    if (isCut) {
      cutRange.each((ri, ci) => {
        this.imageManage.imageRemove(ri, ci,this.overlayerCEl,data);
        console.log("paste clear ri, ci......",ri, ci);
      });
    }
    sheetReset.call(this);
  } else if (evt) {
    const cdata = evt.clipboardData.getData('text/plain');
    this.data.pasteFromText(cdata);
    sheetReset.call(this);
  }
  //粘贴时，判断是否是图片类型，如果是则重新添加图片显示
  data.selector.range.each((ri, ci) => {
    console.log("paste paste ri, ci......",ri, ci);
    let configKey = ri+'-'+ci+'-key';
    let config = null;
    if (data.config && data.config[configKey] && Object.keys(data.config[configKey]).length>0) {
      if (data.config[configKey][type]) {
        config = {...data.config[configKey][type]};
      }
    }
    const style = data.getCellStyle(ri, ci);
    if(style && style.cellimage){
      imageSet.call(this,ri, ci,'cellimage',config);
    }else if(style && style.format){
      if (style.format=='qrcode' || style.format=='barcode' || style.format=='image') {
        imageSet.call(this,ri, ci,style.format,config);
      }
    }
  });
  
}

function hideRowsOrCols() {
  this.data.hideRowsOrCols();
  sheetReset.call(this);
}

function unhideRowsOrCols(type, index) {
  this.data.unhideRowsOrCols(type, index);
  sheetReset.call(this);
}

function autofilter() {
  const { data } = this;
  data.autofilter();
  sheetReset.call(this);
}

function toolbarChangePaintformatPaste() {
  const { toolbar } = this;
  if (toolbar.paintformatActive()) {
    paste.call(this, 'format');
    clearClipboard.call(this);
    toolbar.paintformatToggle();
  }
}

function overlayerMousedown(evt) {
  // console.log(':::::overlayer.mousedown:', evt.detail, evt.button, evt.buttons, evt.shiftKey);
  // console.log('evt.target.className:', evt.target.className);
  const {
    selector, data, table, sortFilter,
  } = this;
  const { offsetX, offsetY } = evt;
  const isAutofillEl = evt.target.className === `${cssPrefix}-selector-corner`;
  const cellRect = data.getCellRectByXY(offsetX, offsetY);
  const {
    left, top, width, height, colLen
  } = cellRect;
  let { ri, ci } = cellRect;
	//代码库修改
	if (colLen == ci) { //点击加号按钮
		this.trigger('cell-selected', null, ri, ci);
		return;
	}
  // sort or filter
  const { autoFilter } = data;
  if (autoFilter.includes(ri, ci)) {
    if (left + width - 20 < offsetX && top + height - 20 < offsetY) {
      const items = autoFilter.items(ci, (r, c) => data.rows.getCell(r, c));
      sortFilter.hide();
      sortFilter.set(ci, items, autoFilter.getFilter(ci), autoFilter.getSort(ci));
      sortFilter.setOffset({ left, top: top + height + 2 });
      return;
    }
  }

  // console.log('ri:', ri, ', ci:', ci);
  if (!evt.shiftKey) {
    // console.log('selectorSetStart:::');
    if (isAutofillEl) {
      selector.showAutofill(ri, ci);
    } else {
      selectorSet.call(this, false, ri, ci);
    }

    // mouse move up
    mouseMoveUp(window, (e) => {
      // console.log('mouseMoveUp::::');
      ({ ri, ci } = data.getCellRectByXY(e.offsetX, e.offsetY));
      if (isAutofillEl) {
        selector.showAutofill(ri, ci);
      } else if (e.buttons === 1 && !e.shiftKey) {
        selectorSet.call(this, true, ri, ci, true, true);
      }
    }, () => {
      if (isAutofillEl && selector.arange && data.settings.mode !== 'read') {
        if (data.autofill(selector.arange, 'all', msg => xtoast('Tip', msg))) {
          table.render();
        }
      }
      selector.hideAutofill();
      toolbarChangePaintformatPaste.call(this);
    });
  }

  if (!isAutofillEl && evt.buttons === 1) {
    if (evt.shiftKey) {
      // console.log('shiftKey::::');
      selectorSet.call(this, true, ri, ci);
    }
  }
}

function imageSetOffset(moveType,distance) {
  const { data } = this;
  this.imageManage.imageSetOffset(moveType,distance,data)
}

function imageSet(ri, ci,type,config) {
  const { data , selector} = this;
  this.imageManage.imageSet(ri, ci,type,this.overlayerCEl,data,config);
  data.clearClipboard();
  selector.hideClipboard();
}

function imageHide(ri, ci) {
  const { data } = this;
  this.imageManage.imageHide(ri, ci,data);
}

function imageClear(ri, ci) {
  const { data } = this;
  this.imageManage.imageHide(ri, ci,data);
}

function dataConfigSet(ri, ci,type,config,isCellConfig=true) {
  const { data , selector} = this;
  this.dataConfigManage.updateConfig(ri, ci,type,data,config,isCellConfig);
  data.clearClipboard();
  selector.hideClipboard();
}

function dataConfigRestore(ri, ci,type,isCellConfig=true) {
  const { data } = this;
  this.dataConfigManage.restoreConfig(ri, ci,type,data,isCellConfig);
}

//清空选择的cell 图片
function clearSelectCellsImage(){
  const { data,table } = this;
  this.imageManage.clearSelectCellsImage(this.overlayerCEl,data);
}

//清空imagesArr数组
function clearQrBarcodes(){
  this.imageManage.clearImagesArr(this.overlayerCEl);
  this.table.imagesArr = [];
}
//获取cell对应type的配置信息
function getConfig(type,isCellConfig=true) {
  const { data } = this;
  const { range } = data.selector;
  const { sri,sci } = range;
  
  if (isCellConfig) {
    let configKey = sri+'-'+sci+'-key';
    let configObj = data.configInit[type];
    let codeOffset = data.cellRect(sri,sci);
    if (configObj && codeOffset) {
      configObj.height = codeOffset.height-4;
    }

    if (data.config && data.config[configKey] && Object.keys(data.config[configKey]).length>0) {
      if (data.config[configKey][type]) {
        configObj = {...data.config[configKey][type]};
      }
    }
    return {...configObj, maxHeight:codeOffset && codeOffset.height}
  } else {
    let configObj = data.configInit[type];
    if (data.config && data.config.config &&  (data.config.config[type]!=undefined || data.config.config[type]!=null)) {
      configObj = data.config.config[type];
    }
    return configObj?configObj:{};
  }
}

//处理资源图片合并单元格
function mergeImages(type,value) {
  const { data } = this;
  this.imageManage.mergeImages(type, value,data,this.overlayerCEl);
}

//处理当行列增加或者删除时，资源this.table.imagesArr、this.imagesArr中ri ci同步更新
function dealBarqrCodesWithRowColAddRemove(editType,rcType){
  const { data,table } = this;
  this.imageManage.dealBarqrCodesWithRowColAddRemove(editType,rcType,data,table,this.overlayerCEl);
  
}

function editorSetOffset() {
  const { editor, data } = this;
  const sOffset = data.getSelectedRect();
  const tOffset = this.getTableOffset();
  let sPosition = 'top';
  // console.log('sOffset:', sOffset, ':', tOffset);
  if (sOffset.top > tOffset.height / 2) {
    sPosition = 'bottom';
  }
  editor.setOffset(sOffset, sPosition);
}

function editorSet() {
  const { editor, data } = this;
  if (data.settings.mode === 'read') return;
  editorSetOffset.call(this);
  editor.setCell(data.getSelectedCell(), data.getSelectedValidator());
  clearClipboard.call(this);
}

function verticalScrollbarMove(distance) {
  console.log('verticalScrollbarMove:',distance);
  const { data, table, selector } = this;
  let _this = this;
  data.scrolly(distance, () => {
    selector.resetBRLAreaOffset();
    editorSetOffset.call(this);
    table.render();
    imageSetOffset.call(this,'vertical',distance);
  });
}

function horizontalScrollbarMove(distance) {
  console.log('horizontalScrollbarMove:',distance);
  const { data, table, selector } = this;
  let _this = this;
  data.scrollx(distance, () => {
    selector.resetBRTAreaOffset();
    editorSetOffset.call(this);
    table.render();
    imageSetOffset.call(this,'horizontal',distance);
  });
}

function rowResizerFinished(cRect, distance) {
  console.log('rowResizerFinished:');
  const { ri } = cRect;
  const { table, selector, data } = this;
  data.rows.setHeight(ri, distance);
  table.render();
  selector.resetAreaOffset();
  verticalScrollbarSet.call(this);
  editorSetOffset.call(this);
  imageSetOffset.call(this,'rowResizer');
}

function colResizerFinished(cRect, distance) {
  console.log('colResizerFinished:');
  const { ci } = cRect;
  const { table, selector, data } = this;
  data.cols.setWidth(ci, distance);
  // console.log('data:', data);
  table.render();
  selector.resetAreaOffset();
  horizontalScrollbarSet.call(this);
  editorSetOffset.call(this);
  imageSetOffset.call(this,'colResizer');
}

function dataSetCellText(text, state = 'finished') {
  const { data, table } = this;
  // const [ri, ci] = selector.indexes;
  if (data.settings.mode === 'read') return;
  data.setSelectedCellText(text, state);
  const { ri, ci } = data.selector;
  if (state === 'finished') {
    table.render();
  } else {
    this.trigger('cell-edited', text, ri, ci);
  }
}

//块设定与取消的处理，取消通过range
function blockDeal(dealType = 'set',blockType,block) {
  const { data , selector} = this;
  let range = null;
  let isCoverSet = false;
  if (!block) {
    range = data.selector.range;
  }else{
    range = block.range || data.selector.range;
    isCoverSet = block.isCoverSet || false;
  }
  // const { range } = data.selector;
  if (dealType == 'set') { //设定块
    //检查选择的单元格是否设置了块
    console.log("insert-block-set checkIsSetBlock......", this.blockManage.checkIsSetBlock(range));
    if (this.blockManage.checkIsSetBlock(range)) {
      if (isCoverSet) {//如果是覆盖设置，则先检查新区域内是否存在别的自定义变量设置
        if (this.blockManage.checkIsSetOtherCustomVariableBlock(range,blockType,block.oldBlock)) {
          this.trigger('msg-alert',{type:'warning',message:"该区域已存在其他自定义变量设置，无法重复设置"});
          block && block.callback && block.callback({status:0,message:"该区域已存在其他自定义变量设置，无法重复设置"});
        } else {
          this.blockManage.blockSet(range,blockType,data,block);
          block && block.callback && block.callback({status:1,message:""});
        }
      }else{
        this.trigger('msg-alert',{type:'warning',message:"该区域已存在块设置，无法重复设置"});
        block && block.callback && block.callback({status:0,message:"该区域已存在块设置，无法重复设置"});
      }
    } else {
      this.blockManage.blockSet(range,blockType,data,block);
      block && block.callback && block.callback({status:1,message:""});
    }
  } else { //取消块设定
    this.blockManage.blockCancel(range,blockType,data,block);
    block && block.callback && block.callback({status:1,message:""});
  }
}
//块取消的处理 通过key批量取消
function blockCancelWithKey(blockType,key) {
  this.blockManage.clearBlocksWithKey(blockType,key);
}
//更新块名称 通过key批量更新
function updateBlockNameWithKey(key,name,blockType) {
  this.blockManage.updateBlockNameWithKey(key,name,blockType);
}

//表单配置区域标题设定与取消的处理
function formAreaDeal(dealType = 'set',range,currentForm,areaType,isFormClear=false,callback) {
  const { data } = this;

  let callbackFunc = msg=>{
    if (msg.success) {
      if (dealType == 'set' || dealType == 'update') {
        this.trigger('set-area-done',{type:areaType,currentForm:currentForm,area:msg.data});
      }else{
        this.trigger('cancel-area-done',{type:areaType,currentForm:currentForm});
      }
      callback && callback(true);
    } else {
      this.trigger('deal-area-error',{type:areaType,currentForm:currentForm});
      this.trigger('msg-alert',{type:'warning',message:msg.message});

      callback && callback(false);
    }
  }
  if (dealType == 'set' || dealType == 'update') { //设定标题
    switch (areaType) {
      case 'area':
        {
          if (dealType == 'update') {
            this.formConfigManage.formAreaSet(range,'formConfigArea',data,currentForm,callbackFunc,true);
          }else{
            this.formConfigManage.formAreaSet(range,'formConfigArea',data,currentForm,callbackFunc,false);
            // if (this.formConfigManage.checkIsSetFormArea(range)) {
            //   //消息提示
            //   this.trigger('msg-alert',{type:'warning',message:"该区域已存在子表范围，无法重复设置"});
            // } else {
            //   this.formConfigManage.formAreaSet(range,'formConfigArea',data,currentForm,callbackFunc,false);
            // }
          } 
        }
        break;
      case 'title':
        this.formConfigManage.formAreaTitleSet(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      case 'title-row':
        this.formConfigManage.formAreaTitleRowSet(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      case 'first-row':
        this.formConfigManage.formAreaFirstRowSet(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      default:
        break;
    }
    
  } else { //取消块设定
    if (isFormClear) {
      range = null;
    }
    switch (areaType) {
      case 'area':
        this.formConfigManage.formAreaCancel(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      case 'title':
        this.formConfigManage.formAreaTitleCancel(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      case 'title-row':
        this.formConfigManage.formAreaTitleRowCancel(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      case 'first-row':
        this.formConfigManage.formAreaFirstRowCancel(range,'formConfigArea',data,currentForm,callbackFunc);
        break;
      default:
        break;
    }
  }
}

//表单配置区域标题设定与取消的处理(通过表单信息)
function formAreaForm(dealType = 'set',currentForm,areaType,isFormClear=false) {
  const { data } = this;
  let { range } = data.selector;
  formAreaDeal.call(this,dealType,range,currentForm,areaType,isFormClear);
}

//表单配置区域标题设定与取消的处理（通过坐标信息）
function formAreaRange(dealType = 'set',range,areaType,callback) {
  const { currentForm } = this;

  formAreaDeal.call(this,dealType,range,currentForm,areaType,false,callback);
}

function insertDeleteRowColumn(type,block) {
  console.log("insertDeleteRowColumn......",type);
  const { table,data,currentForm } = this;
  let isSetBlock = false;
  let isCancelBlock = false;
  if (data.settings.mode === 'read') return;
  if (type === 'insert-row') {
    
    dealBarqrCodesWithRowColAddRemove.call(this,'add','row')
    data.insert('row');
    
  } else if (type === 'delete-row') {
    dealBarqrCodesWithRowColAddRemove.call(this,'delete','row')
    data.delete('row');
    
  } else if (type === 'insert-column') {
		//代码库修改
		this.trigger('col-added',msg=>{
			if (msg.add) {
        dealBarqrCodesWithRowColAddRemove.call(this,'add','column')
				data.insert('column');
        
			}
		});
  } else if (type === 'delete-column') {
		//代码库修改
		this.trigger('col-deleted');
    if (data.cols.len > 8) {
      dealBarqrCodesWithRowColAddRemove.call(this,'delete','column')
    }
    data.delete('column');
    
  } else if (type === 'delete-cell') {
    data.deleteCell();
  } else if (type === 'delete-cell-format') {
    data.deleteCell('format');
  } else if (type === 'delete-cell-text') {
    data.deleteCell('text');
  } else if (type === 'cell-printable') {
    data.setSelectedCellAttr('printable', true);
  } else if (type === 'cell-non-printable') {
    data.setSelectedCellAttr('printable', false);
  } else if (type === 'cell-editable') {
    data.setSelectedCellAttr('editable', true);
  } else if (type === 'cell-non-editable') {
    data.setSelectedCellAttr('editable', false);
  } else if (type === 'cell-disabled') {
    data.setSelectedCellAttr('disabled', true);
  } else if (type === 'cell-non-disabled') {
    data.setSelectedCellAttr('disabled', false);
  }else if (type === 'insert-block-set') {
    blockDeal.call(this,'set','block');
    isSetBlock = true;
  } else if (type === 'insert-block-cancel') {
    blockDeal.call(this,'cancel','block');
    isCancelBlock = true;
  } else if (type === 'row-cycle-block-set') {
    blockDeal.call(this,'set','rowCycleBlock');
    isSetBlock = true;
  } else if (type === 'row-cycle-block-cancel') {
    blockDeal.call(this,'cancel','rowCycleBlock');
    isCancelBlock = true;
  } else if (type === 'column-cycle-block-set') {
    blockDeal.call(this,'set','columnCycleBlock');
    isSetBlock = true;
  } else if (type === 'column-cycle-block-cancel') {
    blockDeal.call(this,'cancel','columnCycleBlock');
    isCancelBlock = true;
  } else if (type === 'custom-variable-block-config') {
    let { range } = data.selector;
    let block = this.blockManage.getBlockWithRange(range);
    this.trigger('config-custom-variable-block', {
      ...block,
    });
    // blockDeal.call(this,'set','customVariableBlock',block);
  }else if (type === 'custom-variable-block-set') {
    blockDeal.call(this,'set','customVariableBlock',block);
  } else if (type === 'custom-variable-block-cancel') {
    blockDeal.call(this,'cancel','customVariableBlock',block);
    isCancelBlock = true;
  } else if (type === 'form-config-area-set') {
    formAreaForm.call(this,'set',currentForm,'area');
  } else if (type === 'form-config-area-cancel') {
    formAreaForm.call(this,'cancel',currentForm,'area');
  } else if (type === 'form-config-title-set') {
    formAreaForm.call(this,'set',currentForm,'title');
  } else if (type === 'form-config-title-cancel') {
    formAreaForm.call(this,'cancel',currentForm,'title');
  } else if (type === 'form-config-title-row-set') {
    formAreaForm.call(this,'set',currentForm,'title-row');
  } else if (type === 'form-config-title-row-cancel') {
    formAreaForm.call(this,'cancel',currentForm,'title-row');
  } else if (type === 'form-config-first-row-set') {
    formAreaForm.call(this,'set',currentForm,'first-row');
  } else if (type === 'form-config-first-row-cancel') {
    formAreaForm.call(this,'cancel',currentForm,'first-row');
  } else if (type === 'barcode-config'){
    const { data } = this;
    const { range } = data.selector;
    const { sri,sci } = range;
    const style = data.getCellStyle(sri, sci);
    if (style && style.format && style.format=='barcode') {
      this.trigger('barcode-config',{
        data:getConfig.call(this,'barcode'),
        func:config=>{
          if (config) {
            imageSet.call(this,sri, sci,'barcode',config);
          }
        }
      });
    } else {
      this.trigger('msg-alert',{type:'warning',message:"请先配置单元格为条码格式"});
    }
		
  }
  clearClipboard.call(this);
  sheetReset.call(this);

  if (isSetBlock) {
    this.trigger('set-block');
  }
  if (isCancelBlock) {
		this.trigger('cancel-block');
  }
}

function toolbarChange(type, value) {
  console.log("type......",type, value);
  console.log("this......",this);
  
  const { data, overlayerCEl,toolbar} = this;
  
  const { ri, ci } = data.selector;
  console.log("ri, ci......",ri, ci);
  if (type === 'undo') {
    this.undo();
    clearQrBarcodes.call(this);
    this.selector.resetData(data);
    this.table.resetData(data);
    this.dealBarqrCodeShow();
    this.dealBackgrounImgShow();
  } else if (type === 'redo') {
    this.redo();
    clearQrBarcodes.call(this);
    this.selector.resetData(data);
    this.table.resetData(data);
    this.dealBarqrCodeShow();
    this.dealBackgrounImgShow();
  } else if (type === 'print') {
    this.print.preview();
  } else if (type === 'printconfig') {
    const { data } = this;
    const { range } = data.selector;
    const { sri,sci } = range;
    const style = data.getCellStyle(sri, sci);
    this.trigger('printconfig',{
      data:getConfig.call(this,'print',false),
      func:config=>{
        if (config) {
          dataConfigSet.call(this,sri, sci,'print',config,false);
        }
      }
    });
  } else if (type === 'exportconfig') {
    const { data } = this;
    const { range } = data.selector;
    const { sri,sci } = range;
    this.trigger('exportconfig',{
      data:getConfig.call(this,'exportconfig',false),
      func:config=>{
        if (config) {
          dataConfigSet.call(this,sri, sci,'exportconfig',config,false);
          data.setSelectedCellAttr(type, false);
          sheetReset.call(this);
        }
      }
    });
    data.setSelectedCellAttr(type, false);
    sheetReset.call(this);
  } else if (type === 'paintformat') {
    if (value === true) copy.call(this);
    else clearClipboard.call(this);
  } else if (type === 'clearformat') {
    insertDeleteRowColumn.call(this, 'delete-cell-format');
    clearSelectCellsImage.call(this);
  } else if (type === 'link') {
    // link
  } else if (type === 'chart') {
    // chart
  } else if (type === 'autofilter') {
    // filter
    autofilter.call(this);
  } else if (type === 'freeze') {
    if (value) {
      this.freeze(ri, ci);
    } else {
      this.freeze(0, 0);
    }
  }
  // 页边距设置
  else if (type === 'pagemargin') {
    this.trigger('pagemargin', {
      data:data.pageMargin,
      func:pagemargin=>{
        if (pagemargin) {
          data.setSelectedCellAttr(type, true);
          data.setPageMargin(pagemargin);
        } else {
          data.setSelectedCellAttr(type, false);
        }
        sheetReset.call(this);
      }
    });
    if (data.pageMargin) {
      data.setSelectedCellAttr(type, true);
    } else {
      data.setSelectedCellAttr(type, false);
    }
    sheetReset.call(this);
  }
  // 背景图设置
  else if (type === 'backgroundimage') {
    if (value) {
      this.trigger('backgroundimage', (imgData)=>{
        //设置背景图
        this.backgroundImg.el.el.style.opacity = "0.5";
        this.backgroundImg.el.el.style.height = "100%";
        this.backgroundImg.el.el.style.backgroundImage = 'url('+data.ossUrl+imgData.url+')';
        this.backgroundImg.show();

        data.setBgUrl(imgData.url);
        sheetReset.call(this);
      });
    }else{
      this.backgroundImg.hide();
      data.setSelectedCellAttr(type, value);
      data.setBgUrl('');
      sheetReset.call(this);
    }
  }
  // 单元格斜线
  else if (type === 'cellslash') {
    if (value) {
      let cellText = data.getCellTextOrDefault(ri, ci);
      let cellStyle = data.getCellStyle(ri, ci);
      data.setSelectedCellAttr(type, !value);
      toolbar.reset();
      this.trigger('cellslash', {
        value:cellText,
        drawstart:cellStyle?cellStyle.cellslashdrawstart:'lefttop',
        func:cellslash=>{
          if (cellslash) {
            clearSelectCellsImage.call(this);
            console.log("cellslash......", cellslash);
            //将 ** | **格式字符拆分，转换成单元格斜线图片显示在单元格中
            //执行单元格显示斜线
            data.setSelectedCellAttr(type, value);
            data.setSelectedCellAttr('cellslashdrawstart', cellslash.drawstart);
            data.setSelectedCellText(cellslash.value, 'finished');
            sheetReset.call(this);
          }
        }
      });
    }else{
      data.setSelectedCellAttr(type, false);
      data.setSelectedCellAttr('cellslashdrawstart', 'lefttop');
      sheetReset.call(this);
    }
  }
  // 单元格图片
  else if (type === 'cellimage') {
    if (value) {
      data.setSelectedCellAttr(type, !value);
      toolbar.reset();
      // sheetReset.call(this);
      this.trigger('cellimage', (imgData)=>{
        clearSelectCellsImage.call(this);
        //设置单元格图片
        data.setSelectedCellAttr(type, value);
        data.setSelectedCellText(imgData.url, 'finished');
        if (!data.selector.multiple()) {
          imageSet.call(this,ri, ci,'cellimage');
        }else if (data.selector.multiple()) {
          const selector = data.selector;
          console.log('selector:', selector);
          imageSet.call(this,selector.range.sri, selector.range.sci,'cellimage');
        }
        sheetReset.call(this);
      });
    }else{
      data.setSelectedCellAttr(type, false);
      data.setSelectedCellText('', 'finished');
      const selector = data.selector;
      this.imageManage.imageRemove(selector.range.sri, selector.range.sci,this.overlayerCEl,data);
      sheetReset.call(this);
    }
  }else {
    data.setSelectedCellAttr(type, value);
    console.log("data.selector.multiple()......",data.selector.multiple());
    if (type === 'merge') {
      clearSelectCellsImage.call(this);
      mergeImages.call(this,type, value);
    }else
    if (type === 'formula' && !data.selector.multiple()) {
      editorSet.call(this);
    }else if (type === 'format' && !data.selector.multiple()) {
      clearSelectCellsImage.call(this);
      //format菜单中 二维码、条形码、图片  单个单元格 单选
      if (value == 'barcode' || value == 'qrcode' || value == 'image') {
        imageSet.call(this,ri, ci,value,getConfig.call(this,value));
      }
    }else if (type === 'format' && data.selector.multiple()) {
      clearSelectCellsImage.call(this);
      //format菜单中 二维码、条形码、图片 多个单元格多选 合并
      if (value == 'barcode' || value == 'qrcode' || value == 'image') {
        const selector = data.selector;
        console.log('selector:', selector);
        imageSet.call(this,selector.range.sri, selector.range.sci,value,getConfig.call(this,value));
      }
    }
    sheetReset.call(this);
		if (type === 'sumportrait') {
			// 纵向求和
			this.trigger('sum-portrait',value);
		} else if (type === 'sumlandscape') {
			// 横向求和
			this.trigger('sum-landscape',value);
		}  
    // 插入二维码、条形码
    else if (type === 'bar_qrcode') {
      this.trigger('saved', this);
    }
  }
}

function sortFilterChange(ci, order, operator, value) {
  // console.log('sort:', sortDesc, operator, value);
  this.data.setAutoFilter(ci, order, operator, value);
  sheetReset.call(this);
}



function sheetInitEvents() {
  const {
    selector,
    overlayerEl,
    rowResizer,
    colResizer,
    verticalScrollbar,
    horizontalScrollbar,
    editor,
    contextMenu,
    contextSubMenu,
    toolbar,
    modalValidation,
    sortFilter,
    resizeLoadFunc
  } = this;
  // overlayer
  overlayerEl
    .on('mousemove', (evt) => {
      overlayerMousemove.call(this, evt);
    })
    .on('mouseup', (evt) => {
      overlayerMouseup.call(this, evt);
    })
    .on('mousedown', (evt) => {
      editor.clear();
      contextMenu.hide();
      // the left mouse button: mousedown → mouseup → click
      // the right mouse button: mousedown → contenxtmenu → mouseup
      if (evt.buttons === 2) {
        console.log("overlayerEl mousedown vt.buttons 2......",evt);
        if (this.data.xyInSelectedRect(evt.offsetX, evt.offsetY)) {
          contextMenu.setPosition(evt.offsetX, evt.offsetY);
        } else {
          overlayerMousedown.call(this, evt);
          contextMenu.setPosition(evt.offsetX, evt.offsetY);
        }
        evt.stopPropagation();
      } else if (evt.detail === 2) {
        console.log("overlayerEl mousedown evt.detail2......",evt);
        console.log("this......",this);
  
        const { data } = this;
        
        const { ri, ci } = data.selector;
        console.log("ri, ci......",ri, ci);
        const cell = data.getCell(ri, ci);
        console.log("cell.....",cell);
        if (cell && cell.disabled) {
          return;
        }

        const style = data.getCellStyle(ri, ci);
        console.log("style.....",style);
        if (style && style.bar_qrcode) {
          
        }else if(style && style.cellimage){
          //双击二维码、条形码无操作
          imageHide.call(this,ri, ci);
          editorSet.call(this);
        }else if(style && style.format){
          if (style.format=='qrcode' || style.format=='barcode' || style.format=='image') {
            //双击二维码、条形码无操作
            imageHide.call(this,ri, ci);
            editorSet.call(this);
          }else{
            editorSet.call(this);
          }
        }else{
          //单元格双击
          editorSet.call(this);
        }
      } else {
        overlayerMousedown.call(this, evt);
      }
    })
    .on('mousewheel.stop', (evt) => {
      overlayerMousescroll.call(this, evt);
    })
    .on('mouseout', (evt) => {
      const { offsetX, offsetY } = evt;
      if (offsetY <= 0) colResizer.hide();
      if (offsetX <= 0) rowResizer.hide();
    });

  selector.inputChange = (v) => {
    console.log("selector.inputChange......",v);
    dataSetCellText.call(this, v, 'input');
    editorSet.call(this);
  };

  // slide on mobile
  bindTouch(overlayerEl.el, {
    move: (direction, d) => {
      overlayerTouch.call(this, direction, d);
    },
  });

  // toolbar change
  toolbar.change = (type, value) => toolbarChange.call(this, type, value);

  // sort filter ok
  sortFilter.ok = (ci, order, o, v) => sortFilterChange.call(this, ci, order, o, v);

  // resizer finished callback
  rowResizer.finishedFn = (cRect, distance) => {
    rowResizerFinished.call(this, cRect, distance);
  };
  colResizer.finishedFn = (cRect, distance) => {
    colResizerFinished.call(this, cRect, distance);
  };
  // resizer unhide callback
  rowResizer.unhideFn = (index) => {
    unhideRowsOrCols.call(this, 'row', index);
  };
  colResizer.unhideFn = (index) => {
    unhideRowsOrCols.call(this, 'col', index);
  };
  // scrollbar move callback
  verticalScrollbar.moveFn = (distance, evt) => {
    verticalScrollbarMove.call(this, distance, evt);
  };
  horizontalScrollbar.moveFn = (distance, evt) => {
    horizontalScrollbarMove.call(this, distance, evt);
  };
  // editor
  editor.change = (state, itext) => {
    if (state != 'input') {
      const { data } = this;
      const { ri, ci } = data.selector;
      const style = data.getCellStyle(ri, ci);
      if (style && style.bar_qrcode) {
        
      }else if(style && style.cellimage){
        imageSet.call(this,ri, ci,'cellimage');
        editor.hide();
      }else if(style && style.format){
        if (style.format=='qrcode' || style.format=='barcode' || style.format=='image') {
          imageSet.call(this,ri, ci,style.format);
          editor.hide();
        }
      }
    }

    dataSetCellText.call(this, itext, state);
  };
  // modal validation
  modalValidation.change = (action, ...args) => {
    if (action === 'save') {
      this.data.addValidation(...args);
    } else {
      this.data.removeValidation();
    }
  };
  // contextmenu
  contextMenu.itemClick = (type) => {
    // console.log('type:', type);
    if (type === 'validation') {
      modalValidation.setValue(this.data.getSelectedValidation());
    } else if (type === 'copy') {
      copy.call(this);
    } else if (type === 'cut') {
      cut.call(this);
    } else if (type === 'paste') {
      paste.call(this, 'all');
    } else if (type === 'paste-value') {
      paste.call(this, 'text');
    } else if (type === 'paste-format') {
      paste.call(this, 'format');
    } else if (type === 'hide') {
      hideRowsOrCols.call(this);
    } else {
      insertDeleteRowColumn.call(this, type);
    }
  };
  // contextmenu
  contextMenu.itemHover = (type,isHide,evt) => {
    console.log('itemHover:', type,isHide);
    if (isHide) {
      contextSubMenu && contextSubMenu.hide(type);
    } else {
      contextSubMenu && contextSubMenu.show(type);
      let menuOffset = contextMenu.getMenuItemOffset(type);
      contextSubMenu.setPosition(menuOffset.left+menuOffset.width, menuOffset.top);
    }
    // if (type === 'insert-block') {

    // } else if (type === 'row-cycle-block') {
      
    // } else if (type === 'column-cycle-block') {
      
    // }
  };

  // contextsubmenu
  contextSubMenu.itemClick = (type) => {
    // console.log('type:', type);
    insertDeleteRowColumn.call(this, type);
  };

  console.log("resizeLoadFunc......",resizeLoadFunc);
  bind(window, 'resize', resizeLoadFunc);

  bind(window, 'click', (evt) => {
    this.focusing = overlayerEl.contains(evt.target);
  });

  bind(window, 'paste', (evt) => {
    if(!this.focusing) return;
    paste.call(this, 'all', evt);
    evt.preventDefault();
  });

  // for selector
  bind(window, 'keydown', (evt) => {
    if (!this.focusing) return;
    const keyCode = evt.keyCode || evt.which;
    const {
      key, ctrlKey, shiftKey, metaKey,
    } = evt;
    // console.log('keydown.evt: ', keyCode);
    if (ctrlKey || metaKey) {
      // const { sIndexes, eIndexes } = selector;
      // let what = 'all';
      // if (shiftKey) what = 'text';
      // if (altKey) what = 'format';
      switch (keyCode) {
        case 90:
          // undo: ctrl + z
          this.undo();
          evt.preventDefault();
          break;
        case 89:
          // redo: ctrl + y
          this.redo();
          evt.preventDefault();
          break;
        case 67:
          // ctrl + c
          copy.call(this);
          evt.preventDefault();
          break;
        case 88:
          // ctrl + x
          cut.call(this);
          evt.preventDefault();
          break;
        case 85:
          // ctrl + u
          toolbar.trigger('underline');
          evt.preventDefault();
          break;
        case 86:
          // ctrl + v
          // => paste
          paste.call(this, 'all');
          evt.preventDefault();
          break;
        case 37:
          // ctrl + left
          selectorMove.call(this, shiftKey, 'row-first');
          evt.preventDefault();
          break;
        case 38:
          // ctrl + up
          selectorMove.call(this, shiftKey, 'col-first');
          evt.preventDefault();
          break;
        case 39:
          // ctrl + right
          selectorMove.call(this, shiftKey, 'row-last');
          evt.preventDefault();
          break;
        case 40:
          // ctrl + down
          selectorMove.call(this, shiftKey, 'col-last');
          evt.preventDefault();
          break;
        case 32:
          // ctrl + space, all cells in col
          selectorSet.call(this, false, -1, this.data.selector.ci, false);
          evt.preventDefault();
          break;
        case 66:
          // ctrl + B
          toolbar.trigger('bold');
          break;
        case 73:
          // ctrl + I
          toolbar.trigger('italic');
          break;
        default:
          break;
      }
    } else {
      // console.log('evt.keyCode:', evt.keyCode);
      switch (keyCode) {
        case 32:
          if (shiftKey) {
            // shift + space, all cells in row
            selectorSet.call(this, false, this.data.selector.ri, -1, false);
          }
          break;
        case 27: // esc
          contextMenu.hide();
          clearClipboard.call(this);
          break;
        case 37: // left
          selectorMove.call(this, shiftKey, 'left');
          evt.preventDefault();
          break;
        case 38: // up
          selectorMove.call(this, shiftKey, 'up');
          evt.preventDefault();
          break;
        case 39: // right
          selectorMove.call(this, shiftKey, 'right');
          evt.preventDefault();
          break;
        case 40: // down
          selectorMove.call(this, shiftKey, 'down');
          evt.preventDefault();
          break;
        case 9: // tab
          editor.clear();
          // shift + tab => move left
          // tab => move right
          selectorMove.call(this, false, shiftKey ? 'left' : 'right');
          evt.preventDefault();
          break;
        case 13: // enter
          editor.clear();
          // shift + enter => move up
          // enter => move down
          selectorMove.call(this, false, shiftKey ? 'up' : 'down');
          evt.preventDefault();
          break;
        case 8: // backspace
          insertDeleteRowColumn.call(this, 'delete-cell-text');
          evt.preventDefault();
          break;
        default:
          break;
      }

      if (key === 'Delete') {
        insertDeleteRowColumn.call(this, 'delete-cell-text');
        evt.preventDefault();
      } else if ((keyCode >= 65 && keyCode <= 90)
        || (keyCode >= 48 && keyCode <= 57)
        || (keyCode >= 96 && keyCode <= 105)
        || evt.key === '='
      ) {
        console.log("keyCode......",keyCode);
        dataSetCellText.call(this, evt.key, 'input');
        editorSet.call(this);
      } else if (keyCode === 113) {
        // F2
        editorSet.call(this);
      }
    }
  });
}

export default class Sheet {
  constructor(targetEl, data) {
    //存储临时条形码、二维码显示信息
    this.imagesArr = [];
    //存储圈定区域类型
    this.areaType = '';//area:子表区域  title:子表标题区域 title-row:子表标题行区域 first-row:首选行
    //当前所属表单
    /**
     * {table_id:'',tableName:''}
     */
    this.currentForm = null;
    this.eventMap = createEventEmitter();
    const { view, showToolbar, showContextmenu,showContextmenuAddCol } = data.settings;
    this.el = h('div', `${cssPrefix}-sheet`);
    this.toolbar = new Toolbar(data, view.width, !showToolbar);
    this.print = new Print(data);
    targetEl.children(this.toolbar.el, this.el, this.print.el);
    this.data = data;
    // table
    this.tableEl = h('canvas', `${cssPrefix}-table`);
    // resizer
    this.rowResizer = new Resizer(false, data.rows.minHeight);
    this.colResizer = new Resizer(true, data.cols.minWidth);
    // scrollbar
    this.verticalScrollbar = new Scrollbar(true);
    this.horizontalScrollbar = new Scrollbar(false);
    // editor
    this.editor = new Editor(
      formulas,
      () => this.getTableOffset(),
      data.rows.height,
    );
    // data validation
    this.modalValidation = new ModalValidation();
    // contextMenu
    this.contextMenu = new ContextMenu(() => this.getRect(), !showContextmenu,showContextmenuAddCol,data.cols.len);
    // contextSubMenu
    this.contextSubMenu = new ContextSubMenu(() => this.getRect(), !showContextmenu,showContextmenuAddCol,data.cols.len);
    // selector
    this.selector = new Selector(data);
    this.backgroundImg = new BackgroundImage(
      formulas,
      () => this.getTableOffset(),
      data.rows.height,
      data.bgUrl,
    );
    this.overlayerCEl = h('div', `${cssPrefix}-overlayer-content`)
      .children(
        this.editor.el,
        this.selector.el,
        this.backgroundImg.el
      );
    this.overlayerEl = h('div', `${cssPrefix}-overlayer`)
      .child(this.overlayerCEl);
    // sortFilter
    this.sortFilter = new SortFilter();
    // root element
    this.el.children(
      this.tableEl,
      this.overlayerEl.el,
      this.rowResizer.el,
      this.colResizer.el,
      this.verticalScrollbar.el,
      this.horizontalScrollbar.el,
      this.contextMenu.el,
      this.contextSubMenu.el,
      this.modalValidation.el,
      this.sortFilter.el,
    );
    // table
    this.table = new Table(this.tableEl.el, data);

    this.imageManage = new ImageManage(this.overlayerCEl,data,this.table);
    this.blockManage = new BlockManage(this.overlayerCEl,data,this.table);
    this.dataConfigManage = new DataConfigManage(data,this.table);
    this.formConfigManage = new FormConfigManage(this.overlayerCEl,data,this.table);
    this.resizeLoadFunc = ()=>{
      this.reload();
    };

    sheetInitEvents.call(this);
    sheetReset.call(this);
    // init selector [0, 0]
    selectorSet.call(this, false, 0, 0);
  }

  on(eventName, func) {
    this.eventMap.on(eventName, func);
    return this;
  }

  clearEvents(){
    unbind(window, 'resize',this.resizeLoadFunc)
    this.eventMap.removeAllListeners();
    return this;
  }

  trigger(eventName, ...args) {
    const { eventMap } = this;
    eventMap.fire(eventName, args)
  }

  resetData(data) {
    
    // before
    this.editor.clear();
    // after
    this.data = data;
    verticalScrollbarSet.call(this);
    horizontalScrollbarSet.call(this);
    // clearClipboard.call(this);
    this.toolbar.resetData(data);
    this.print.resetData(data);
    this.selector.resetData(data);
    this.table.resetData(data);
    this.dealBarqrCodeShow();
    this.dealBackgrounImgShow();
    this.blockManage.setBlockMsg(data.blocks)
    this.formConfigManage.setFormAreaMsg(data.formAreas)

    this.selector.hideClipboard();
  }

  dealBarqrCodeShow(){
    console.log("dealBarqrCodeShow......",this.table.imagesArr);
    this.imageManage.clearImagesArr(this.overlayerCEl);
    if (this.table.imagesArr && this.table.imagesArr.length>0) {
      this.table.imagesArr.forEach(barqrcode => {
        imageSet.call(this,barqrcode.ri, barqrcode.ci,barqrcode.type,barqrcode.config);
      });
    }
    this.table.imagesArr = [];
  }
  dealBackgrounImgShow(){
    this.backgroundImg.hide();
    if (this.data.bgUrl) {
      //设置背景图
      this.backgroundImg.el.el.style.opacity = "0.5";
      this.backgroundImg.el.el.style.height = "100%";
      this.backgroundImg.el.el.style.backgroundImage = 'url('+this.data.ossUrl+this.data.bgUrl+')';//
      this.backgroundImg.show();
    }
  }

  loadData(data) {
    this.data.setData(data);
    this.blockManage.setBlockMsg(data.blocks);
    this.formConfigManage.setFormAreaMsg(data.formAreas)
    sheetReset.call(this);
    return this;
  }

  // freeze rows or cols
  freeze(ri, ci) {
    const { data } = this;
    data.setFreeze(ri, ci);
    sheetReset.call(this);
    return this;
  }

  undo() {
    this.data.undo();
    sheetReset.call(this);
  }

  redo() {
    this.data.redo();
    sheetReset.call(this);
  }

  reload() {
    sheetReset.call(this);
    return this;
  }

  getRect() {
    const { data } = this;
    return { width: data.viewWidth(), height: data.viewHeight() };
  }

  getTableOffset() {
    const { rows, cols } = this.data;
    const { width, height } = this.getRect();
    return {
      width: width - cols.indexWidth,
      height: height - rows.height,
      left: cols.indexWidth,
      top: rows.height,
    };
  }

  deleteCellImageSlash(type){
    insertDeleteRowColumn.call(this,type);
  }

  //设置当前表单
  setCurrentForm(form){
    this.currentForm = form;
  }
  //清空表单
  clearCurrentForm(){
    this.currentForm = null;
  }

  //设置区域类型
  setAreaType(type){
    this.areaType = type;
  }
  //清空区域类型
  clearAreaType(){
    this.areaType = '';
  }

  //通过form清空某个表的区域设置
  clearFormArea(form,type){
    formAreaForm.call(this,'cancel',form,type,true);
  }

  //设置某个表的区域
  setFormAreaWithRange(range,type,callback){
    let Range = new CellRange(range.sri,range.sci,range.eri,range.eci);
    formAreaRange.call(this,'set',Range,type,callback);
  }

  //更新某个表的区域
  updateFormAreaWithRange(range,type,callback){
    let Range = new CellRange(range.sri,range.sci,range.eri,range.eci);
    formAreaRange.call(this,'update',Range,type,callback);
  }

  //通过所在区域清空某个表的区域设置
  clearFormAreaWithRange(range,type){
    let Range = new CellRange(range.sri,range.sci,range.eri,range.eci);
    formAreaRange.call(this,'cancel',Range,type);
  }

  //获取选择的区域所在的子表区域信息
  getSubTableAreaMsg(selectRange){
    let range = new CellRange(selectRange.sri,selectRange.sci,selectRange.eri,selectRange.eci);
    return this.formConfigManage.checkIsSetFormArea(range,null,true);
  }

  //设置块:
  setBlock(type,block){
    if (block && block.range) {
      let range = new CellRange(block.range.sri,block.range.sci,block.range.eri,block.range.eci);
      block.range = range;
    }
    this.blockManage.setBlockMsg(this.data.blocks);
    insertDeleteRowColumn.call(this,type,block);
  }
  //更新块名称
  updateBlockName(key,blockName,type){
    updateBlockNameWithKey.call(this,key,blockName,type);
  }

  //取消块设定
  cancelBlockWithRange(type,block){
    if (block && block.range) {
      let range = new CellRange(block.range.sri,block.range.sci,block.range.eri,block.range.eci);
      block.range = range;
    }
    insertDeleteRowColumn.call(this,type,block);
  }
  //取消块设定
  cancelBlockWithKey(type,blockKey){
    blockCancelWithKey.call(this,type,blockKey);
  }
  //设置单元格的格式
  setCellFormat(format){
    toolbarChange.call(this,'format',format);
  }
  //设置sheet是否聚焦状态
  setFocusing(focusing){
    this.focusing = focusing;
  }
}
